import React from "react";
import { Button, ButtonProps } from "@mui/material";
import { EditPencil } from "assets";

interface ConfigurationButtonProps extends Omit<ButtonProps, 'startIcon' | 'onClick'> {
    onEditMode: boolean;
    onToggleEditMode: () => void;
    onSave?: () => void;
    editText?: string;
    saveText?: string;
    disabled?: boolean;
    width?: string | number;
    backgroundColor?: string;
    borderRadius?: string | number;
}

export const ConfigurationButton = ({
    onEditMode,
    onToggleEditMode,
    onSave,
    editText = "Edit Configuration",
    saveText = "Save Configuration",
    disabled = false,
    width = '200px',
    backgroundColor = '#191FDB',
    borderRadius = "8px",
    ...buttonProps
}: ConfigurationButtonProps) => {

    const handleClick = () => {
        if (onEditMode && onSave) {
            onSave();
        }
        onToggleEditMode();
    };

    return (
        <Button
            variant="contained"
            startIcon={<EditPencil />}
            sx={{
                borderRadius,
                width,
                background: backgroundColor,
                ...buttonProps.sx
            }}
            onClick={handleClick}
            disabled={disabled}
            data-testid="configuration-btn"
            {...buttonProps}
        >
            {onEditMode ? saveText : editText}
        </Button>
    );
}; 